import { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"

export default function Riddles() {
  const [data, setData] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  
  useEffect(() => {
    getJoke();
  }, []);

  function getJoke() {
    axios
      .get(`https://api.api-ninjas.com/v1/riddles`, {
        headers: {
        'X-Api-Key': 'Gw3tcN5LZG2oW1L/BJpVCw==YR80Ob5bfND1qydI'
        }
      })
      .then((response) => {
        setData(response.data);
        console.log("ress", response?.data)
        setQuestion(response.data[0].question);
        setAnswer('');
      })
      .catch((error) => {
        console.error('Error fetching joke:', error);
      });
  }

  function getAnswer() {
    if (data.length > 0) {
      setAnswer(data[0].answer);
    }
  }

  let apiKey = "Gw3tcN5LZG2oW1L/BJpVCw==YR80Ob5bfND1qydI";

  return (
    <section className="h-[100vh] bg-white w-[100%] " >
      <section className='flex flex-col items-center justify-center bg-[#272635] py-[50px]'>
        <div className='head animate__animated animate__bounce'>
          <h1 className='text-[#B1E5F2] text-[100px]'>RIDDLE</h1>
          <h2 className='text-[#A6A6A8] text-[100px]'>TOWN!!</h2>
          <h3 className='text-[#B1E5F2]'>by Lani Sho</h3>
        </div>
      </section>

      <section className='expoSpace px-[40px] py-[30px] flex flex-col items-center justify-center'>
      <div className='qa'>
      <div className='joke'>
          <h1>Riddle: {question}</h1>
        </div>

        {answer && (
          <div className='border border-solid border-[1px] p-[10px] rounded-[15px] mt-[20px] joke'>
            <h1>Answer: {answer}</h1>
           </div>
        )}
      </div>
      </section>

      <section className='flex flex-col items-center justify-center expoSpace'>
        <div className='w-[70%] flex pb-[20px] '>
          <button onClick={() => {

          getJoke()}} className='p-[15px] text-[white] bg-[#000000] rounded-[40px] w-[100%]'>Next Riddle <i className='bx bx-chevron-right'></i></button>
        </div>
        <div className='w-[70%] flex pb-[20px] '>
          <button onClick={getAnswer} className='bg-transparent text-[#000000] border-solid border-[1px] border-[] w-[100%] p-[15px] rounded-[40px]'>View Answer <i className='bx bx-chevron-right'></i></button>
        </div>
        <div className='num'>
          <h1>2023</h1>
        </div>
      </section>
      <section className='text-[#000000] expoSpace w-[100%] text-[40px] flex flex-row  items-center justify-center pt-[30px]'>
        <a href='https://twitter.com/tolani_is?s=21&t=5kREoGoxMqsgn4YGzJUj4g' target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faXTwitter} style={{color: "black"}} /></a>
        <a href='https://github.com/ibrahimSho31' target='_blank' rel='noopener noreferrer'  className='px-[30px]'><i className='bx bxl-github' ></i></a>
        <a href='https://www.linkedin.com/in/ibrahim-shokoya-85a032258/' target='_blank' rel='noopener noreferrer'><i className='bx bxl-linkedin-square' ></i></a>
      </section>
    </section>
  );
}

